<template>
    <div class="wrap">
        <div class="container">
            <h3 class="personal_titile">重置密码</h3>
            <div class="adddz chardz">
              <form>
                <div class="address_require">
                  <label>新密码<span>*</span></label>
                  <input type="password" v-model="pwd">
                </div>
                <div class="address_require">
                  <label>确认新密码<span>*</span></label>
                  <input type="password" v-model="pwd2">
                </div>
              </form>
            </div>
            <br/>
            <van-row type="flex" align="center" justify="center">
              <van-col span="20">
                <van-button block type="primary" @click="doupdate()">重置密码</van-button>
              </van-col>
            </van-row>
        </div>
        <v-foot></v-foot>
    </div>
</template>

<script>
    var _this;
    // @ is an alias to /src
    export default {
        components: {},
        created(){
            _this = this;
            this.email = this.$route.query.email;
            this.token = this.$route.query.token;
        },
        data() {
            return {
              "pwd":"",
              "pwd2":"",
              "email":"",
              "token":"",

            }
        },
        methods: {
          doupdate() {
            if(this.pwd != this.pwd2){
                this.$toast("密码不一致，再试一次.");
                return;
            }
            this.POST("api/user/forgetpwdfromemail",{"pwd":this.pwd,"accounts":this.email,"token":this.token},function(d){
              _this.$toast(d.msg);
              if(d.code == 0){
                setTimeout(function(){
                  _this.$router.push('login');
                },1111);
              }
            });
          }
        },
    }
</script>